import React from "react";
import "../../../../stylesheets/components/Reports/HoldingReports/SmcasePopupSuccess.scss";
import { Link, useParams } from "react-router-dom";
import * as URLConfig from "@frameworks/web/config/domain";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { useSelector } from "react-redux";
const SmcasePopupSuccessMob = (props) => {
    var _a, _b;
    const { loginOrigin } = useParams();
    const salesNativeApp = JSON.parse(localStorage.getItem("sales_native_app"));
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginOrigin !== LoginSource.SALES &&
        !salesNativeApp &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const setUrl = (pathName) => {
        const destination = pathName +
            "?reportName=" +
            props.pageName.replace(/\s/g, "") +
            (props.tabName ? "&tab=" + props.tabName : "");
        return destination;
    };
    const orderStatus = () => {
        localStorage.setItem("orderstatus", "true");
        window.open(URLConfig.config.oldWebUrl, "_blank");
    };
    return (React.createElement("div", { className: "mob-smallcase-popup-success container" },
        React.createElement("div", { className: `mob-smallcase-popup-success-body  ${!isClientLogin && "not-client-login"} icon-100` },
            React.createElement("i", { className: "edel-icon-success-popup icon" }, Array(7)
                .fill("")
                .map((i, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` })))),
            ((_b = (_a = props.Title) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === null || _b === void 0 ? void 0 : _b.includes("Sqaure off For Position".toUpperCase())) && (React.createElement("i", { className: "edel-icon-success-popup" }, Array(7)
                .fill("")
                .map((i, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` }))))),
            props.messageReactNode ? (React.createElement(React.Fragment, null,
                props.messageReactNode,
                !isClientLogin && !props.disablePnPassword && (React.createElement("div", { className: "py-2" },
                    React.createElement(PANPassword, { reportText: props === null || props === void 0 ? void 0 : props.aifPdfText }))))) : (React.createElement("label", { className: "update-message" }, props.message ? (React.createElement(React.Fragment, null,
                React.createElement("span", { dangerouslySetInnerHTML: { __html: props.message } }),
                !isClientLogin && !props.disablePnPassword && (React.createElement("div", { className: "py-2" },
                    React.createElement(PANPassword, { reportText: props === null || props === void 0 ? void 0 : props.aifPdfText }))))) : (React.createElement(React.Fragment, null,
                "Your request was successfully processed.",
                !isClientLogin && !props.disablePnPassword && (React.createElement("div", { className: "py-2" },
                    React.createElement(PANPassword, { reportText: props === null || props === void 0 ? void 0 : props.aifPdfText })))))))),
        React.createElement("span", { className: "action-post-success" }, !(props === null || props === void 0 ? void 0 : props.sendBack) ? (React.createElement(Link, { to: setUrl(getLoginSourceURL(loginOrigin)) },
            React.createElement("button", { onClick: () => {
                    var _a;
                    (_a = props === null || props === void 0 ? void 0 : props.closeDrawer) === null || _a === void 0 ? void 0 : _a.call(props);
                } },
                React.createElement("i", { className: "edel-icon-left-shortArrow twist" }),
                props.goBackText ? "Go Back" : `Go Back To ${props.pageName}`))) : (React.createElement("button", { onClick: () => {
                var _a, _b;
                // window.location.reload();
                (_a = props === null || props === void 0 ? void 0 : props.closeDrawer) === null || _a === void 0 ? void 0 : _a.call(props);
                (_b = props === null || props === void 0 ? void 0 : props.goBack) === null || _b === void 0 ? void 0 : _b.call(props);
            } },
            React.createElement("i", { className: "edel-icon-left-shortArrow twist" }),
            props.goBackText ? "Go Back" : `Go Back To ${props.pageName}`)))));
};
export default SmcasePopupSuccessMob;
